import { AuthRoutes } from "../modules/auth";
import { HomeRoutes } from "../modules/home";

const PublicRoutes = [...AuthRoutes, ...HomeRoutes];
export default PublicRoutes;
